const box1_bg = document.querySelector('.gradient-bg');
const box1_but = document.querySelector('.box1-info .buy-now_but');
const box1_video = document.querySelector('#box1-video');
const box1_img = document.querySelector('.img-video picture');

const box3_tab_div = document.querySelector('.tab-div');
const box3_tab_style = window.getComputedStyle(box3_tab_div);
const box3_tab_div_left = parseFloat(box3_tab_style.paddingLeft);
const box3_tab = document.querySelectorAll('.tab-div .tab');

const box3_tab_content = document.querySelectorAll('.tab-content .content');
const box3_video1 = document.querySelector('#box3-video1');
const box3_video2 = document.querySelector('#box3-video2');
const box3_video_img1 = document.querySelector('#box3-video1_img');
const box3_video_img2 = document.querySelector('#box3-video2_img');

const video1 = document.querySelector('#box5-1-video')
const video2 = document.querySelector('#box5-2-video')
const video3 = document.querySelector('#box5-3-video')
const video4 = document.querySelector('#box5-4-video')
const box5SlidesLi = document.querySelectorAll('#box5-splide .splide__list li');

const box6SlidesLi = document.querySelectorAll('.box6-splide-ul li');
const box6_video1 = document.querySelector('#box6-video1');
const box6_video2 = document.querySelector('#box6-video2');
const box6_img1 = document.querySelector('#box6-img1');
const box6_img2 = document.querySelector('#box6-img2');

ScrollTrigger.create({
  trigger: '.box5-scroll',
  start: 'top center',
  scrub: true,
  once: true,
  onEnter(){
    click_video_anime(0)
  }
})

ScrollTrigger.create({
  trigger: '.box3',
  start: 'top bottom',
  scrub: true,
  once: true,
  onEnter(){
    box3_video1.load();
    box3_video2.load();
  }
})

ScrollTrigger.create({
  trigger: '.box5',
  start: 'top bottom',
  scrub: true,
  once: true,
  onEnter(){
    document.querySelector('#box5-1-video').load();
    document.querySelector('#box5-2-video').load();
    document.querySelector('#box5-3-video').load();
    document.querySelector('#box5-4-video').load();
  }
})

box3_tab.forEach((item,index) =>{
  item.addEventListener('click',()=>{

    box3_video1.currentTime = 0;  
    box3_video2.currentTime = 0;  

    if(index == 0){
      box3_video2.pause();
      box3_video2.classList.remove('is');
      box3_video_img2.classList.remove('is');
      box3_tab_div.style.setProperty('--before-x', '0px');

      let box3Video1 = box3_video1.play();
      box3_video1.classList.add('is');
      if (box3Video1 !== undefined) {
        box3Video1.then(_ => {
          box3_video1.addEventListener('ended', () => {
            box3_video_img1.classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }  
    }else{
      box3_video1.pause();
      box3_video_img1.classList.remove('is');
      box3_video1.classList.remove('is');
      box3_tab_div.style.setProperty('--before-x', (item.offsetLeft-box3_tab_div_left) +'px');
      
      let box3Video2 = box3_video2.play();
      box3_video2.classList.add('is');
      if (box3Video2 !== undefined) {
        box3Video2.then(_ => {
          box3_video2.addEventListener('ended', () => {
            box3_video_img2.classList.add('is');
          });

        })
        .catch(error => {
          console.log(error)
        });
      }  
    }

    box3_tab.forEach(item2 => {
      item2.classList.remove("active");
    })
    box3_tab_content.forEach(item2 => {
      item2.classList.remove("active");
    })
    
  
    box3_tab[index].classList.add("active");
    box3_tab_content[index].classList.add("active");
  })
})

ScrollTrigger.matchMedia({
  "(min-width: 750px)": function() {
    box1_img.classList.remove('active');
    
    box1_video.load();
    box1_video.play();

    box1_video.addEventListener('timeupdate', () => {
      if (box1_video.currentTime >= 1.2) {
        box1_bg.classList.add('active');
      }
    });
    box1_video.addEventListener('ended', () => {
      box1_but.classList.add('active');
      box1_img.classList.add('active');
    });

    replaceVideoSource('box5-1-video', 'https://cdn.shopify.com/videos/c/o/v/c4659a575adc473098de23d998697c38.mp4');
    replaceVideoSource('box5-2-video', 'https://cdn.shopify.com/videos/c/o/v/e9170c9a30554627bb19e94773704949.mp4');
    replaceVideoSource('box5-3-video', 'https://cdn.shopify.com/videos/c/o/v/1bc2c417c3f249c2841b59427f590495.mp4');
    replaceVideoSource('box5-4-video', 'https://cdn.shopify.com/videos/c/o/v/13568a136909454197673795c501369a.mp4');

    ScrollTrigger.create({
      trigger: '.box6-box',
      start: 'top top',
      scrub: true,
      pin:true,
      onEnter(){
        box6_video1.load();
        box6_video2.load();
      },
      animation:
        gsap.timeline()
        .to('.box6-card.card2',{transform: 'translateY(0px)'})
        .to('.box6-card.card3',{transform: 'translateY(0px)'})
    })

    setResponsiveVideoSource(box3_video1, {
      url: [
        { src: "http://www.boox.com/wp-content/uploads/2025/04/02_b.mov", type: "video/quicktime" },
        { src: "https://cdn.shopify.com/videos/c/o/v/73bec1f7292649d694fbc7cce4926833.webm", type: "video/webm" },
        { src: "https://cdn.shopify.com/videos/c/o/v/9ff7f346fd0e41d391044b9d677b02db.mp4", type: "video/mp4" }
      ]
    });
    setResponsiveVideoSource(box3_video2, {
      url: [
        { src: "http://www.boox.com/wp-content/uploads/2025/04/02_a.mov", type: "video/quicktime" },
        { src: "https://cdn.shopify.com/videos/c/o/v/dbdd9ea723bb4377913c4fc2c2c8c575.webm", type: "video/webm" },
        { src: "https://cdn.shopify.com/videos/c/o/v/54e9d0dd00684160883e6972749399bd.mp4", type: "video/mp4" }
      ]
    });

  },
  "(max-width: 750px)": function() {
    box1_bg.classList.add('active');
    box1_but.classList.add('active');
    box1_img.classList.add('active');

    replaceVideoSource('box5-1-video', 'https://cdn.shopify.com/videos/c/o/v/96179612c67b41f1b0314f94dc260c27.mp4');
    replaceVideoSource('box5-2-video', 'https://cdn.shopify.com/videos/c/o/v/4f0d5d22eb9a4739b659fa3aba140a10.mp4');
    replaceVideoSource('box5-3-video', 'https://cdn.shopify.com/videos/c/o/v/69ca31a4ea9245e1b4024c104b373b7e.mp4');
    replaceVideoSource('box5-4-video', 'https://cdn.shopify.com/videos/c/o/v/580e0ecb605448b797200652c6b6f64e.mp4');
    
    setResponsiveVideoSource(box3_video1, {
      url: [
        { src: "https://cdn.shopify.com/videos/c/o/v/9ff7f346fd0e41d391044b9d677b02db.mp4", type: "video/mp4" }
      ]
    });
    setResponsiveVideoSource(box3_video2, {
      url: [
        { src: "https://cdn.shopify.com/videos/c/o/v/54e9d0dd00684160883e6972749399bd.mp4", type: "video/mp4" }
      ]
    });
  }
})

const box5Splide = new Splide('#box5-splide', {
  perPage    : 2,
  perMove    : 1,
  focus  : 'center',
  trimSpace  : false,
  drag : false,
  pagination: false,
  updateOnMove: true,
  gap: '25px',
  autoWidth: true,
  breakpoints: {
    1920: {
      perPage: 2,
      gap: '18px'
    },
    750: {
      perPage: 1.25,
      gap: '15px',
      autoWidth: false,
      drag : true
    }
  }
}).mount();

box5SlidesLi.forEach((slide, index) => {
  slide.addEventListener('click', () => {
    box5Splide.go(index); // 切换到点击的 Slide
  });
});

// 添加监听事件
box5Splide.on('move', () => {
  const activeIndex = box5Splide.index;
  click_video_anime(activeIndex)
});

const box6Splide =  new Splide( '#box6-splide', {
  type  : 'fade',
  perPage: 1,
  arrows: false,
  autoWidth: false
} ).mount();

box6Splide.on('move', () => {
  const activeIndex = box6Splide.index;
  box6SlidesLi[activeIndex].click();
});

box6SlidesLi.forEach((slide, index) => {

  slide.addEventListener('click', () => {
    box6SlidesLi.forEach(item => {
      item.classList.remove("active");
    })
    box6SlidesLi[index].classList.add("active");

    box6Splide.go(index); // 切换到点击的 Slide

    if(index === 3){
      const playPromise = box6_video1.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {

          box6_video1.onended = () => {
            if (box6_img1) {
              box6_img1.classList.add('active');
            }
          };

        }).catch(error => {

        });
      }else {
        box6_video1.pause();
        box6_video1.currentTime = 0;
      }
    }else{
      box6_video1.pause();
      box6_video1.currentTime = 0;
      box6_img1.classList.remove('active');
    }

    if(index === 4){
      const playPromise = box6_video2.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {

          box6_video2.onended = () => {
            if (box6_img2) {
              box6_img2.classList.add('active');
            }
          };

        }).catch(error => {

        });
      }else {
        box6_video2.pause();
        box6_video2.currentTime = 0;
      }
    }else{
      box6_video2.pause();
      box6_video2.currentTime = 0;
      box6_img2.classList.remove('active');
    }
  });

});

new Splide( '#box7-splide-left', {
  type   : 'loop',
  drag   : 'free',
  focus  : 'center',
  arrows: false, // 取消箭头
  pagination: false, // 取消下标
  perPage: 4.5,
  breakpoints: {
    992: {
        perPage: 4
    },
    750: {
      perPage: 2
    }
  },
  autoScroll: {
    speed: 0.5,
    pauseOnHover: false,
  }
  
} ).mount( window.splide.Extensions );

new Splide( '#box7-splide-right', {
  type   : 'loop',
  drag   : 'free',
  focus  : 'center',
  arrows: false, // 取消箭头
  pagination: false, // 取消下标
  perPage: 4.5,
  breakpoints: {
    992: {
        perPage: 4
    },
    750: {
      perPage: 2
    }
  },
  autoScroll: {
    speed: -0.5,
    pauseOnHover: false
  }
  
} ).mount( window.splide.Extensions );

new Splide('#box11-splide', {
  type   : 'loop',
  perPage: 2,
  focus  : 'center',
  lazyLoad: 'nearby',
  pagination: false,
  gap:'25px',
  breakpoints: {
    1920: {
      perPage: 2,
    },
    1024: {
      perPage: 1.5,
    },
    750: {
      perPage: 1.5,
      gap:'10px'
    }
  }
}).mount(); 

function replaceVideoSource(videoId, newSrc) {
  const videoElement = document.getElementById(videoId);
  if (!videoElement) {
    return;
  }

  const sourceElement = videoElement.querySelector('source');
  if (!sourceElement) {
    return;
  }

  sourceElement.src = newSrc;
}

function click_video_anime(index){
  
  const itemImg = document.querySelectorAll('#box5-splide .splide__slide .item .item-img')
  const img2 = document.querySelectorAll('#box5-splide .splide__slide .item .video-img2')


  itemImg.forEach((item) => item.classList.remove('is'));
  img2.forEach((item) => item.classList.remove('is'));

  video1.currentTime = 0;
  video2.currentTime = 0;
  video3.currentTime = 0;
  video4.currentTime = 0;
  video1.pause();
  video2.pause();
  video3.pause();
  video4.pause();

  if(index + 1 === 1){

    let playPromise1 = video1.play();

    if (playPromise1 !== undefined) {
      playPromise1.then(_ => {
        itemImg[index].classList.add('is');
        video1.addEventListener('ended', () => {
          img2[index].classList.add('is');
        });

      })
      .catch(error => {
        console.log(error)
      });
    }
    
  }

  if(index + 1 === 2){

    let playPromise2 = video2.play();
    if (playPromise2 !== undefined) {
      playPromise2.then(_ => {
        itemImg[index].classList.add('is');
        video2.addEventListener('ended', () => {
          itemImg[index].classList.add('is');
          img2[index].classList.add('is');
        });

      })
      .catch(error => {
        console.log(error)
      });
    }

  }

  if(index + 1 === 3){

    let playPromise3 = video3.play();

    if (playPromise3 !== undefined) {
      
      playPromise3.then(_ => {
        itemImg[index].classList.add('is');
        video3.addEventListener('ended', () => {
          itemImg[index].classList.add('is');
          img2[index].classList.add('is');
        });
      })
      .catch(error => {
        console.log(error)
      });
    }

  }

  if(index + 1 === 4){

    let playPromise4 = video4.play();
    if (playPromise4 !== undefined) {
      playPromise4.then(_ => {
        itemImg[index].classList.add('is');
        video4.addEventListener('ended', () => {
          itemImg[index].classList.add('is');
          img2[index].classList.add('is');
        });

      })
      .catch(error => {
        console.log(error)
      });
    }   

  }

}

// 切换视频
function setResponsiveVideoSource(videoElement, options) {
  if (!videoElement) return;
  const sources = options.url;
  // 清除旧的 source 标签
  while (videoElement.firstChild) {
    videoElement.removeChild(videoElement.firstChild);
  }

  // 添加新的 source
  sources.forEach(sourceInfo => {
    const source = document.createElement('source');
    source.src = sourceInfo.src;
    source.type = sourceInfo.type;
    videoElement.appendChild(source);
  });

  videoElement.load();
}

